import closeIcon from "./close.svg"
import React from "react";
import {useHistory} from "react-router-dom";
import customAxios from "../../../service/api/interceptors";

type Props = {
    closeBanner: () => void,
    text: string
    ctaName: string
    ctaUrl: string
    id: number
}

export const BannerUnderHeader: React.FC<Props> = ({ closeBanner, text, ctaName, ctaUrl, id }) => {
    const history = useHistory();

    const clickAnalytics = async () => {
        await customAxios.post(`/banner/${id}/c-t-a-clicked`)
    }

    return (
        <div className={"banners__header"}>
            <div className="banners__header-text">
                {text}
            </div>
            <div className={"banners__header-actions"}>
                {ctaName && ctaUrl && <div onClick={() => {
                    clickAnalytics()
                    history.push(ctaUrl)
                }} className="banners__header-cta">
                    {ctaName}
                </div>}
                <div onClick={closeBanner} className="banners__header-close">
                    <img src={closeIcon} alt=""/>
                </div>
            </div>
        </div>
    )
}